import { render } from "./EnglishLuage.vue?vue&type=template&id=3b4fda4e&scoped=true"
import script from "./EnglishLuage.vue?vue&type=script&lang=js"
export * from "./EnglishLuage.vue?vue&type=script&lang=js"

import "./EnglishLuage.vue?vue&type=style&index=0&id=3b4fda4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b4fda4e"]])

export default __exports__